export default __webpack_public_path__ + "static/media/050_brake_01.1105c6a3.mp3";